(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-product-rail]').forEach(row => {
      if (row.dataset.ready) return;
      row.dataset.ready = 'true';
      const track = row.querySelector('.pt-rail-track'), prev = row.querySelector('[data-rail-prev]'), next = row.querySelector('[data-rail-next]'), count = row.querySelector('[data-rail-count]'), message = row.querySelector('[data-rail-message]');
      let busy = false, total = Number(row.dataset.total), page = 1;
      const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const update = () => {
        const cards = [...track.children], card = cards[0]; if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        const first = Math.round(track.scrollLeft / step) + 1, visible = Math.max(1, Math.round(track.clientWidth / step));
        count.textContent = row.dataset.countTemplate.replace('[first]', first).replace('[last]', Math.min(first + visible - 1, cards.length)).replace('[total]', total);
        prev.disabled = track.scrollLeft < 2;
        next.disabled = busy || (cards.length >= total && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2);
      };
      const advance = async () => {
        const loaded = track.children.length;
        if (busy) return;
        if (loaded < total && track.scrollLeft + 2 * track.clientWidth >= track.scrollWidth - 2) {
          busy = true; message.hidden = false; message.textContent = row.dataset.loadingLabel; track.setAttribute('aria-busy', 'true'); update();
          try {
            const url = new URL(row.dataset.collectionUrl, location.origin); url.searchParams.set('section_id', 'pt-rail-page'); url.searchParams.set('page', page + 1);
            const response = await fetch(url, {credentials:'same-origin'}); if (!response.ok) throw new Error('load');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const fragment = doc.querySelector('[data-rail-page]'); if (!fragment) throw new Error('markup');
            const known = new Set([...track.children].map(c => c.dataset.productId));
            const cards = [...fragment.querySelectorAll('.pt-rail-card')].filter(c => !known.has(c.dataset.productId));
            if (!cards.length) total = loaded; else track.append(...cards);
            page += 1; row.dataset.page = page; message.hidden = true;
          } catch (error) {message.textContent = row.dataset.errorLabel; busy = false; track.removeAttribute('aria-busy'); update(); return;}
          busy = false; track.removeAttribute('aria-busy');
        }
        track.scrollBy({left:track.clientWidth + parseFloat(getComputedStyle(track).columnGap),behavior:motion()}); update();
      };
      prev.addEventListener('click', () => track.scrollBy({left:-(track.clientWidth + parseFloat(getComputedStyle(track).columnGap)),behavior:motion()}));
      next.addEventListener('click', advance);
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {if (event.target !== track) return;if(event.key === 'ArrowRight'){event.preventDefault();advance();}if(event.key === 'ArrowLeft'){event.preventDefault();prev.click();}});
      new ResizeObserver(update).observe(track); update();
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
